require('./client-js/scripts');
window.toastr = require('toastr');
$('.change-language').on('change', function (){
    window.location.href = $(this).val()
})

let enabledUnsubscribe = true;
$('#unsubscribe-check').on('change', function (){
    enabledUnsubscribe = !enabledUnsubscribe;
    $('#unsubscribe-btn').prop('disabled', enabledUnsubscribe);
})
